'use strict';

export default function routes($stateProvider) {
	'ngInject';

	$stateProvider.state('application_main', {
			url: '/applications',
			template: require('./applications/applications.html'),
			controller: 'ApplicationsController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_info', {
			url: '/application/:id/info',
			template: require('./info/info.html'),
			controller: 'AppInfoController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_storyboard', {
			url: '/application/:id/storyboard',
			template: require('./storyboard/storyboard.html'),
			controller: 'AppStoryboardController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_style', {
			url: '/application/:id/style',
			template: require('./style/style.html'),
			controller: 'AppStyleController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_main', {
			url: '/application/:id/main',
			template: require('./main/main.html'),
			controller: 'AppMainController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_greenBackground', {
			url: '/application/:id/greenBackground',
			template: require('./greenBackground/greenBackground.html'),
			controller: 'AppGreenBackgroundController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_frame', {
			url: '/application/:id/frame',
			template: require('./frame/frame.html'),
			controller: 'AppFrameController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_preview', {
			url: '/application/:id/preview',
			template: require('./preview/preview.html'),
			controller: 'AppPreviewController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_result', {
			url: '/application/:id/result',
			template: require('./result/result.html'),
			controller: 'AppResultController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_data', {
			url: '/application/:id/data',
			template: require('./data/data.html'),
			controller: 'AppDataController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_filter', {
			url: '/application/:id/filter',
			template: require('./filter/filter.html'),
			controller: 'AppFilterController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_share', {
			url: '/application/:id/share',
			template: require('./share/share.html'),
			controller: 'AppShareController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_quantity', {
			url: '/application/:id/quantity',
			template: require('./quantity/quantity.html'),
			controller: 'AppQuantityController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_end', {
			url: '/application/:id/end',
			template: require('./end/end.html'),
			controller: 'AppEndController',
			controllerAs: 'vm',
			authenticate : true
		})
		.state('application_screen_gallery', {
			url: '/application/:id/gallery',
			template: require('./gallery/gallery.html'),
			controller: 'AppGalleryController',
			controllerAs: 'vm',
			authenticate : true
		});
		
}



// WEBPACK FOOTER //
// ./client/app/application/application.routes.js